
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
async function $01fb213f724084b9$export$2e2bcd8739ae039(path, delay = 10000) {
    const $sliders = document.querySelector(path);
    const $slides = Array.from($sliders.querySelectorAll("img"));
    const total = $slides.length;
    let current = 1;
    $slides[0].style.zIndex = 2;
    $slides.forEach(($slide)=>{
        $slide.style.visibility = "hidden";
    });
    await Promise.all($slides.filter((img)=>!img.complete).map((img)=>new Promise((resolve)=>{
            img.onload = img.onerror = resolve;
        })));
    $slides.forEach(($slide)=>{
        $slide.style.visibility = "visible";
    });
    setInterval(()=>{
        $slides.forEach(($slide, i)=>{
            $slide.style.zIndex = 1;
            $slide.hidden = true;
            $slide.classList.remove("enter-active", "enter-to", "leave-active", "leave-to");
            if (i === current) {
                $slide.style.zIndex = 2;
                $slide.hidden = false;
                $slide.classList.add("enter-from");
                setTimeout(()=>{
                    $slide.classList.remove("enter-from");
                    $slide.classList.add("enter-active", "enter-to");
                }, 100);
            } else if (i === (current + total - 1) % total) {
                $slide.hidden = false;
                $slide.classList.add("leave-from");
                setTimeout(()=>{
                    $slide.classList.remove("leave-from");
                    $slide.classList.add("leave-active", "leave-to");
                }, 100);
            }
        });
        current = (current + 1) % total;
    }, delay);
}


var $0078edeb7a61051b$exports = {};
$0078edeb7a61051b$exports = JSON.parse('{"2024-04-14":{"text":"Rendez-vous","place":"Brocante de Printemps Cabris","link":"https://www.facebook.com/Officedetourismecabris"},"2024-05-26":{"text":"Souhaitez","place":"La f\xeate des M\xe8res","link":"https://icalendrier.fr/fetes/fete-des-meres"},"2024-06-15":{"text":"Rendez-vous","place":"March\xe9 Nocturne Cabris","link":"https://www.facebook.com/Officedetourismecabris"},"2024-07-07":{"text":"Rendez-vous","place":"March\xe9 Artisanal Cabris","link":"https://www.facebook.com/Officedetourismecabris"},"2024-07-19":{"text":"Rendez-vous","place":"March\xe9 Nocturne Cabris","link":"https://www.facebook.com/Officedetourismecabris"},"2024-08-16":{"text":"Rendez-vous","place":"March\xe9 Nocturne Cabris","link":"https://www.facebook.com/Officedetourismecabris"},"2024-12-15":{"text":"Rendez-vous","place":"March\xe9 de No\xebl Cabris","link":"https://www.facebook.com/Officedetourismecabris"}}');


const $87c18728f283bc8d$var$DAYS_BEFORE = 50;
const $87c18728f283bc8d$var$$news = document.querySelector("#news");
const $87c18728f283bc8d$var$$text = $87c18728f283bc8d$var$$news.querySelector("[data-text]");
const $87c18728f283bc8d$var$$day = $87c18728f283bc8d$var$$news.querySelector("[data-day]");
const $87c18728f283bc8d$var$$month = $87c18728f283bc8d$var$$news.querySelector("[data-month]");
const $87c18728f283bc8d$var$$year = $87c18728f283bc8d$var$$news.querySelector("[data-year]");
const $87c18728f283bc8d$var$$place = $87c18728f283bc8d$var$$news.querySelector("[data-place]");
const $87c18728f283bc8d$var$$link = $87c18728f283bc8d$var$$news.querySelector("[data-link]");
function $87c18728f283bc8d$export$2e2bcd8739ae039() {
    let i = 0;
    for (const [date, item] of Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($0078edeb7a61051b$exports))))){
        const eventDate = new Date(date).setHours(23, 59, 59, 999);
        const today = new Date();
        i++;
        if (eventDate >= today && eventDate - $87c18728f283bc8d$var$DAYS_BEFORE * 86400000 <= today) {
            $87c18728f283bc8d$var$$text.textContent = item.text;
            $87c18728f283bc8d$var$$place.textContent = item.place;
            $87c18728f283bc8d$var$$link.href = item.link;
            $87c18728f283bc8d$var$$day.textContent = new Date(date).getDate();
            $87c18728f283bc8d$var$$month.textContent = new Date(date).toLocaleString("fr", {
                month: "long"
            });
            $87c18728f283bc8d$var$$year.textContent = new Date(date).getFullYear();
            if (i % 2 === 0) $87c18728f283bc8d$var$$news.classList.add("secondary");
            else $87c18728f283bc8d$var$$news.classList.add("primary");
            return;
        }
    }
    $87c18728f283bc8d$var$$news.remove();
}


(0, $01fb213f724084b9$export$2e2bcd8739ae039)("#slider", 7000);
(0, $87c18728f283bc8d$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.d8d95ed6.js.map
